import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * duration: type → label → required → [Advanced: width, placeholder, input unit, display format, prefillLastValue]
 *
 * Canonical storage is seconds; input unit controls editor/runtime entry UX.
 */
export function getDurationFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    advancedSection(
      COMMON_FIELD_CONFIGS['width'],
      COMMON_FIELD_CONFIGS['placeholder'],
      {
        key: 'durationInputUnit',
        type: 'select',
        defaultValue: 'minutes',
        props: {
          label: 'formBuilder.duration.inputUnit',
          options: [
            { value: 'seconds', label: 'formBuilder.duration.unit.seconds' },
            { value: 'minutes', label: 'formBuilder.duration.unit.minutes' },
            { value: 'hours', label: 'formBuilder.duration.unit.hours' },
            { value: 'days', label: 'formBuilder.duration.unit.days' },
          ],
        },
      },
      {
        key: 'durationDisplayFormat',
        type: 'select',
        defaultValue: 'short',
        props: {
          label: 'formBuilder.duration.displayFormat',
          options: [
            { value: 'short', label: 'formBuilder.duration.displayFormat.short' },
            { value: 'long', label: 'formBuilder.duration.displayFormat.long' },
          ],
        },
      },
      COMMON_FIELD_CONFIGS['prefillLastValue'],
    ),
  ];
}
